import React from 'react'
import { Toaster } from 'sonner'

import { useTheme } from '@/utils/hooks/useTheme'

/**
 * Global toast outlet, mounted once in entry.js. Takes no props; fire toasts from anywhere
 * with `toast`, `toast.success`, `toast.error`, `toast.warning`, `toast.info`, or
 * `toast.promise` from `@/components/toasts/toast.helpers` (sonner's API; pass the caught
 * error as `toast.error(message, { cause: error })` so a 403 says the user lacks permission).
 * Toasts appear top-center, auto-dismiss after 4 seconds, follow the active light or dark
 * theme, and are styled via the global `.toast-message` class.
 * @import import { Toasts } from '@/components/toasts/Toasts'
 */
export const Toasts = () => {
  const theme = useTheme()

  return (
    <Toaster
      position="top-center"
      duration={4000}
      toastOptions={{ className: 'toast-message' }}
      expand={false}
      theme={theme}
      richColors
      visibleToasts={Infinity}
    />
  )
}
